<template>
    <div>
        <div>
            <div class="hero bg-light int-page">
                <TDSHead/>
            </div>
            <div v-if="loaded">
                <div class="updates-anchor" v-if="newsList.generic.length > 0"
                     :class="{'is-hide': !showBannerNewsList}">
                    <a href="#updates" v-smooth-scroll>
                        <div class="updates-anchor--content">
                            <img class="updates-anchor--content--wheel"
                                 :src="`${publicPath}svg/updates-wheel-${currentLanguage}.svg`" height="35" alt="">
                            <img class="updates-anchor--content--icon" src="../assets/svg/icon_updates.svg" height="35"
                                 alt="">
                        </div>
                    </a>
                </div>
                <div class="container main-content">
                    <div class="container race-detail--wrapper">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="race-detail--wrapper--body">
                                    <div class="row">
                                        <div class="col-lg-12 mb-0 d-lg-flex align-items-end justify-content-between">
                                            <div class="race-detail--wrapper--body--header">
                                                <div class="race-detail--wrapper--body--header--eyebrow">
                                                    {{data.DisciplineID | sport}}
                                                </div>
                                                <h2 class="race-detail--wrapper--body--header--title" v-if="data.BeginDate === data.RaceDate">{{data.RaceDate|date}}</h2>
                                              <h2 class="race-detail--wrapper--body--header--title" v-if="data.BeginDate !== data.RaceDate">{{data.BeginDate|date}} <span class="d-md-none"></span> - <br class="d-md-none"> {{data.RaceDate|date}}</h2>

                                              <h1 class="race-detail--wrapper--body--header--subtitle">
                                                    {{data.Description}}</h1>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <div v-if="maps" class="race-detail--wrapper--body--description">
                                                {{data.Location}}
                                            </div>
                                            <div class="mt-2 mt-lg-4 text-center">
                                                <div class="text-left">
                                                    <div class="text-dark font-weight-normal" v-if="data.Organizer">
                                                        {{$t('event_organiser_detail.title')}}
                                                    </div>
                                                    <div class="h5 m-0 mb-0 font-weight-bold text-dark"
                                                         v-if="data.Organizer">{{data.Organizer}}
                                                    </div>
                                                    <div v-if="data.EntryMail" class="m-0 d-inline-block">
                                                        <a class="text-secondary border-bottom font-weight-normal d-inline-block"
                                                           :href="'mailto:'+data.EntryMail">{{$t('event_organiser_detail.write_email')}}</a>
                                                        <div class="m-0 d-inline-block mx-1 text-secondary font-weight-normal">
                                                            {{$t('event_organiser_detail.or')}}
                                                        </div>
                                                    </div>
                                                    <div class="m-0 d-inline-block font-weight-normal"
                                                         v-if="data.WebSite">
                                                        <a class="text-secondary border-bottom d-inline-block"
                                                           target="_blank" :href="data.WebSite"
                                                           @click="track('navigation','links',data.TrackingCategory,'sito organizzatore')">{{$t('event_organiser_detail.go_to_website')}}</a>
                                                        <div class="m-0 d-inline-block mx-1 text-secondary font-weight-normal d-inline-block">
                                                            {{$t('event_organiser_detail.organiser')}}
                                                        </div>
                                                    </div>
                                                </div>

                                              <div class=" row mt-4 text-left">
                                              <!--        <div class="col-4 pr-0">
                                                        <div class="text-left mr-2"
                                                             v-if="isActiveForFuture(data.Services.EntryLink)">
                                                            <a class="btn btn-primary btn-block" :href="data.EntryUrl"
                                                               target="_blank">
                                                                <span>{{$t('subscribe')}}</span>
                                                                <img class="ml-2"
                                                                     src="../assets/svg/ext-link-arrow-light.svg"
                                                                     height="10" alt="">
                                                            </a>
                                                        </div>
                                                    </div>-->
                                                    <div class="col-12 pl-0">
                                                        <div
                                                             v-if="isActiveForFuture(data.Services.EntryCheck)">
                                                            <b-button variant="btn btn-light btn-block"
                                                                      v-b-modal.verifica_iscrizione>
                                                                <span>{{$t('athlete_details.title')}}</span>
                                                                <img src="../assets/svg/check-icon-primary.svg"
                                                                     class="ml-2"
                                                                     height="18" alt="">
                                                            </b-button>
                                                            <b-modal id="verifica_iscrizione"
                                                                     centered
                                                                     hide-footer
                                                                     size="lg"
                                                                     @hide="onHideVerificaIscrizione"
                                                                     @show="onShowVerifica">
                                                                <template v-slot:modal-title>
                                                                    {{$t('athlete_details.title')}} <br>
                                                                    {{data.Description}}
                                                                </template>
                                                                <VerificaIscrizione :data="data"
                                                                                    ref="modale-iscrizione"/>
                                                            </b-modal>
                                                        </div>
                                                    </div>


                                                </div>


                                                <div class="mt-2 mt-lg-4" v-if="data.LinkedRaces.length > 0 ">
                                                    <b-button
                                                            variant="btn btn-light btn-lg btn-block btn-gare-precedenti"
                                                            v-b-modal.gare_precedenti
                                                            v-on:click="isHide = !isHide">
                                                        <span>{{$t('linked_race.title')}}</span>
                                                        <!--<img src="../assets/svg/check-icon-primary.svg" class="ml-2" height="18" alt="">-->
                                                    </b-button>
                                                    <b-modal id="gare_precedenti"
                                                    centered
                                                    hide-footer
                                                    size="lg"
                                                    @hide="onHideVerificaIscrizione"
                                                    @show="onShowVerifica">
                                                        <LinkedRace :data="data" v-if="data && data.LinkedRaces.length > 0"></LinkedRace>

                                                    </b-modal>
                                                </div>


                                                <div class="list-label-race--wrapper" v-if="label">
                                                    <!-- Non tutte le gare hanno una label o ci sono label diverse quindi specifichiamo meglio -->
                                                    <ul class="list-label-race--wrapper--list">
                                                        <li class="list-label-race--wrapper--list--item"
                                                            v-if="Array.isArray(label)">
                                                            <div class="d-flex align-items-center justify-content-between small"
                                                                 v-for="ev in label" :key="ev.name">
                                                                <img height="40" :src="ev.label">
                                                                <!--<div>{{ev.name}}</div>-->
                                                            </div>
                                                        </li>
                                                        <li class="list-label-race--wrapper--list--item" v-else>
                                                            <!-- Tutte le gare hanno questa label -->
                                                            <img height="40" :src="label">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="mt-lg-4" v-if="data.Infoline">
                                                <span class="mt-3 p-3 border border-primary rounded text-primary font-weight-normal text-center d-inline-block">
                                                <img src="../assets/svg/icon-message.svg" height="24" class="mr-1"
                                                     alt="">
                                                    <span v-html="data.Infoline"></span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-7 mt-1 mt-md-5 mb-3 mb-md-0">
                                            <div class="race-detail--wrapper--media" v-if="data">
                                                <img :src="data.ImageUrl" class="race-detail--wrapper--media--image">
                                                <div class="m-0 mb-1 text-dark text-center mt-2"
                                                     v-if="data.Series.length > 0">
                                                    <div v-for="serie in data.Series" :key="serie.ID">
                                                        <div class="d-flex align-items-start align-items-lg-center justify-content-between p-3 rounded bg-white border border-light">
                                                            <img :src="serie.ImageUrl" v-if="serie.ImageUrl"
                                                                 height="40">
                                                            <div>
                                                                <!--<div class="small font-weight-bold ml-3">{{serie.Description}}</div>-->
                                                                <a :href="serie.LinkUrl" target="_blank"
                                                                   class="text-dark font-weight-normal border-secondary border-bottom"
                                                                   v-if="serie.LinkUrl">{{$t('event_organiser_detail.go_to_website')}}</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!--TODO: da inserire le traduzioni-->
                                            <div v-if="data.Services.PhotoServiceName"
                                                 class="d-none d-md-block w-100 text-secondary text-center font-weight-normal mt-4"
                                                 style="letter-spacing: 1px">
                                                {{$t('event_organiser_detail.title_photo')}}
                                                {{data.Services.PhotoServiceName}}
                                                <!--                                                <div v-if="isPica">e disponibile su <a class="text-secondary" href="https://www.getpica.com" target="_blank">getpica.com</a> <img class="ml-1" src="../assets/svg/ext-link-arrow-secondary.svg" height="8" alt=""></div>-->
                                            </div>
                                            <!--<div v-if="data.Services.PhotoServiceName" class="h5 m-0 mb-0 font-weight-bold text-dark">{{data.Services.PhotoServiceName}}</div>-->
                                            <!--<div v-if="data.Services.PhotoServiceUrl" class="m-0 d-inline-block font-weight-normal">-->
                                            <!--<a class="text-secondary border-bottom d-inline-block"-->
                                            <!--target="_blank" :href="data.Services.PhotoServiceUrl">{{$t('event_organiser_detail.go_to_website')}}</a>-->
                                            <!--<div class="m-0 d-inline-block mx-1 text-secondary font-weight-normal d-inline-block">-->
                                            <!--{{$t('event_organiser_detail.photo_service')}}-->
                                            <!--</div>-->
                                            <!--</div>-->


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container race-detail--wrapper border-0 mb-4" v-if="hasMessages">
                    <div class="row">
                        <div role="tablist" class="accordion-wrapper w-100">
                            <b-card no-body class="accordion-wrapper--item mb-0 border-0">
                                <b-card-header header-tag="header" class="bg-white border-0" role="tab">
                                    <div class="accordion-wrapper--item--header" v-b-toggle.msg--race--accordion>
                                        <div class="accordion-wrapper--item--header--hgroup">
                                            <div class="accordion-wrapper--item--header--hgroup-title">
                                                {{$t('msg_race.title')}}<!-- {{data.Description}}-->
                                            </div>
                                        </div>
                                        <div class="accordion-wrapper--item--header--more-btn--wrapper">
                                            <div class="accordion-wrapper--item--header--more-btn--wrapper--btn">
                                                {{$t('msg_race.more_btn')}}
                                            </div>
                                            <!--<img src="../assets/svg/more-icon.svg" class="accordion-wrapper&#45;&#45;item&#45;&#45;header&#45;&#45;more-btn&#45;&#45;icon">-->
                                        </div>
                                    </div>
                                </b-card-header>
                                <b-collapse id="msg--race--accordion" accordion="msg--accordion" role="tabpanel">
                                    <b-card-body class="accordion-wrapper--item--wrapper--content bg-white">
                                        <div class="row py-2">
                                            <div class="col-lg-8 offset-lg-2">
                                                <div class="msg-race--wrapper" v-if="msg_race_generic">
                                                    <div class="msg-race--wrapper--body" v-for="msg in msg_race_generic"
                                                         :key="msg">
                                                        <div v-html="msg"></div>
                                                    </div>
                                                </div>
                                                <div class="msg-race--wrapper" v-if="msg_entry_lookup">
                                                    <div class="msg-race--wrapper--body" v-for="msg in msg_entry_lookup"
                                                         :key="msg">
                                                        <div v-html="msg"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                        </div>
                    </div>
                </div>
<div class="container-fluid race-detail--wrapper bg-light">
                    <div class="row" v-if="sub && sub.events.length > 0 && !sub.isOver">
                        <div class="text-center w-100">
                            <div class="col-12">
                                <div class="text-muted rounded text-center pt-4 pt-xl-6 pb-4 px-2 px-lg-3 pb-xl-6">
                                    <Iscriviti :data="data"></Iscriviti>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid race-detail--wrapper bg-light"
                     v-if="event && (isToday(data.Services.Result) || isAvailableForFuture(data.Services.Result))">
                    <div class="row">
                        <div class="text-center w-100">
                            <div class="col-12">
                                <div class="text-muted rounded text-center pt-4 pt-xl-6 pb-4 px-2 px-lg-3 pb-xl-6">
                                    <div class="font-weight-bold text-dark h4 font-family-sans-serif m-0"
                                         v-if="isAvailableForFuture(data.Services.Result)">
                                        {{$t('services_list.at_race_date_chart')}}
                                    </div>
                                    <div class="font-weight-bold text-dark h4 font-family-sans-serif m-0"
                                         v-if="isToday(data.Services.Result)">
                                        {{$t('services_list.coming_today_chart')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container" v-if="event && isActiveForFuture(data.Services.EntryList)">
                    <div class="row">
                        <div class="col-12">
                            <div class="bg-light text-center rounded py-4 d-flex align-items-center justify-content-between px-4 pl-lg-5 mt-5 mb-6">
                                <div class="d-flex align-items-center">
                                    <img src="../assets/svg/icon-auth-primary.svg" height="40" alt="">
                                    <div class="text-left ml-3">
                                        <div class="h5 font-family-sans-serif text-primary m-0">
                                            {{$t('athlete_list.title')}}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <ListaIscritti :id="data.ID" :data="data"></ListaIscritti>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container" v-if="event && isActive(data.Services.Result) && data.Services.ResultUrl">
                    <div class="row">
                        <div class="col-12">
                            <div class="bg-light text-center rounded py-4 d-flex align-items-center justify-content-between px-4 pl-lg-5 mt-5 mb-6">
                                <div class="d-flex align-items-center">
                                    <img src="../assets/svg/chart-icon.svg" height="40" alt="">
                                    <div class="text-left ml-3">
                                        <div class="h5 font-family-sans-serif text-primary m-0">
                                            <a  :href="data.Services.ResultUrl" target="_blank">
                                            {{$t('chart_external_label')}}
                                            </a>
                                        </div>
                                        <div class="h6 font-family-sans-serif m-0">{{$t('chart_external_description_label')}}</div>
                                    </div>
                                </div>
                                <div>
                                    <a class="btn btn-primary ml-2" :href="data.Services.ResultUrl" target="_blank">
                                        <img src="../assets/svg/ext-link-arrow-light.svg" height="12" alt="">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container race-detail--wrapper" v-if="hasResults">
                    <Classifica ref="classifica" :data="data" :event="event"/>
                    <div v-if="data.Services.PhotoServiceName"
                         class="d-flex align-items-center justify-content-between bg-light rounded py-3 px-4 text-center font-weight-normal my-2"
                         style="letter-spacing: 1px">

                        <div>
                            {{$t('event_organiser_detail.title_photo')}}
                        </div>
                        <div>
                            <a class="text-dark" :href="data.Services.PhotoServiceUrl"
                               @click="track('navigation','links',data.TrackingCategory,'sito fotografo')"
                               target="_blank">{{data.Services.PhotoServiceName}} <img
                                    src="../assets/svg/ext-link-arrow-dark.svg" height="8" alt=""></a>
                        </div>


                    </div>
                    <!--<div class="row" v-if="event && event.Downloads">-->
                        <!--<div class="col-md-12">-->
                            <!--<div class="d-flex align-items-center justify-content-center py-3 rounded mb-2"-->
                                 <!--v-if="!logged">-->
                                <!--<img src="../assets/svg/lock-icon.svg" class="mr-3" height="20" alt="">-->
                                <!--<div class="mr-3">{{$t('login_for_download_chart')}}</div>-->
                                <!--<Login></Login>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="d-flex align-items-center justify-content-center py-3 rounded mb-2" v-else>-->
                        <!--<img src="../assets/svg/lock-icon.svg" class="mr-3" height="20" alt="">-->
                        <!--<div class="mr-3">{{$t('login_for_download_chart')}}</div>-->
                        <!--<Login></Login>-->
                    <!--</div>-->
                    <a name="updates" id="updates"></a>
                    <div class="col-12 mt-8 mb-6" v-if="newsList.generic.length > 0" ref="newsListGeneric">
                        <div class="text-primary font-weight-normal d-block font-weight-bold h2 text-center pb-3 font-family-sans-serif">
                            {{$t('updates')}}
                        </div>
                        <div class="bg-light pt-3 px-3 rounded overflow-hidden">
                            <div v-for="news in newsList.generic" :key="news.ID" class="cursor-pointer">
                                <div class="p-4 bg-white rounded mb-3 d-flex align-items-center justify-content-between"
                                     @click="modaleNews(news)">
                                    <div>{{news.Title}}</div>
                                    <div>
                                        <img src="../assets/svg/open-modal.svg" height="25" :alt="news.Title">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-2 mt-lg-6 mb-4 mb-lg-6" v-if="newsList.event.length > 0">
                        <div class="text-primary font-weight-normal d-block font-weight-bold h2 text-center pb-3 font-family-sans-serif">
                            {{$t('updates')}} {{data.Description}}
                        </div>
                        <div class="bg-light pt-1 pt-lg-3 px-1 px-lg-3 rounded overflow-hidden">
                            <div role="tablist" class="accordion-wrapper">
                                <!-- Todo: news.ID non esiste! -->
                                <b-card no-body class="accordion-wrapper--item" v-for="(news,index) in newsList.event"
                                        :key="index">
                                    <b-card-header header-tag="header" class="p-0 border-0" role="tab">
                                        <div class="accordion-wrapper--item--header" href="#"
                                             v-b-toggle="'accordion-serie-'+index">
                                            <div class="d-flex align-items-center w-100">
                                                <div class="accordion-wrapper--item--header--hgroup w-100 mt-0 mt-lg-0">
                                                    <div class="accordion-wrapper--item--header--hgroup-eyebrow">
                                                        {{news.IssueDate|dateWithTime}}
                                                    </div>
                                                    <div class="accordion-wrapper--item--header--hgroup-title">
                                                        {{news.Title}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div><img :alt="$t('event_organiser_detail.more')"
                                                      src="../assets/svg/more-icon.svg" height="20"></div>
                                            <!--<div class="d-block d-lg-none mt-3 btn btn-outline-secondary btn-sm">{{$t('event_organiser_detail.more')}}</div>-->
                                        </div>
                                    </b-card-header>
                                    <b-collapse class="accordion-wrapper--item--wrapper"
                                                :id="'accordion-serie-'+index" accordion="my-accordion"
                                                role="tabpanel">
                                        <b-card-body class="accordion-wrapper--item--wrapper--content">
                                            <div class="h6 font-family-sans-serif" v-html="news.Body"></div>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="event">
                    <div class="container-fluid bg-light py-6"
                         v-if="data.Services.Entry == 1 || data.Services.Entry == 2">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <div v-if="data.Services.Entry == 1"
                                             class="w-100 h4 mt-3 px-1 px-lg-4 d-flex align-items-center justify-content-between">
                                            <div class=" w-100">
                                                <div class="w-100 text-center">
                                                    <div class="text-primary font-weight-normal d-block font-weight-bold h2">
                                                        {{$t('subscriptions_open.title')}}
                                                    </div>
                                                    <div class="d-block">{{$t('subscriptions_open.description')}}</div>
                                                    <div class="d-block mt-4 h6">
                                                        <router-link tag="a" :to="$i18nRoute({name:'home'})"
                                                                     class="text-dark">
                                                            <img src="../assets/svg/back-arrow.svg" height="12" alt="">
                                                            <span class="ml-2">{{$t('subscriptions_open.cta')}}</span>
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="data.Services.Entry == 2"
                                             class="w-100 mt-3 px-1 px-lg-4 d-flex align-items-center justify-content-between">
                                            <div class="w-75">
                                                <div class="text-primary font-weight-normal d-block font-weight-bold h2">
                                                    {{$t('subscriptions_open.title')}}
                                                </div>
                                                <div class="h4">{{$t('subscriptions_open.description')}}</div>
                                            </div>
                                            <div>
                                                <!-- Todo: inserire il link per iscriversi -->
                                                <a target="_blank" href="#" class="bg-orange py-3 px-4 d-block rounded">
                                                    <span class="h6 text-white font-weight-bold mr-2">{{$t('subscriptions_open.cta')}}</span>
                                                    <img src="../assets/svg/ext-link-arrow-light.svg" height="8" alt="">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid bg-light" v-if="banner.race.length > 0 && loaded">
                <div class="container py-4 py-md-6 d-flex align-items-center justify-content-between">
                    <div class="h2 text-center font-weight-bold text-uppercase text-primary"><span
                            class="small d-block text-muted">{{data.Description}}</span><span
                            class="h3 m-0 font-weight-bold">Official partner</span></div>
                    <div v-for="banner in banner.race" :key="banner.ID" class="border-light text-center">
                        <div v-for="banner in banner.race" :key="banner.ID" class="mr-lg-2">
                            <a :href="banner.LinkUrl" target="_blank" :title="banner.Description"><img class="img-fluid"
                                                                                                       :src="banner.ImageUrl"></a>
                        </div>
                    </div>
                </div>
            </div>


        </div>
        <!--<LinkedRace :data="data" v-if="data && data.LinkedRaces.length > 0"></LinkedRace>
        <form :action="downloadClassForm.action" method="post" ref="downloadClass">
            <input type="hidden" name="filename" :value="downloadClassForm.filename">
        </form>-->
        <TDSFoot/>
    </div>
</template>

<script>
    import VerificaIscrizione from '../components/VerificaIscrizione'
    import ListaIscritti from '../components/ListaIscritti'
    import Login from '../components/Login'
    import BaseRace from '../components/BaseRace'
    import {EventBus} from '../util/event-bus.js'
    import Classifica from '../components/Classifica'
    import LinkedRace from '../components/LinkedRace'
    import Iscriviti from '../components/Iscriviti'


    export default {
        extends: BaseRace,
        name: 'race',
        components: {
            Iscriviti,
            Login,
            VerificaIscrizione,
            ListaIscritti,
            Classifica,
            LinkedRace
        },
        data() {
            return {
                mod_news: {
                    Title: '',
                    Body: ''
                }, banner: {
                    race: [],
                    top: []
                }, newsList: {
                    generic: [],
                    event: []
                },
                showBannerNewsList: true,
                posNewsList: 0,
                offsetNewsList: 300,
                event: {},                
                sub: null
            }
        },
        metaInfo() {
            return {
                title: (this.loaded ? this.data.TrackingCategory + ' - TDS.sport' : 'Race'),
                meta: [
                    {
                        name: 'description',
                        content: 'content di prova'
                    },
                    {
                        og_title: 'og:title',
                        content: (this.loaded ? this.data.TrackingCategory + ' - TDS.sport' : 'TDS.sport')
                    },
                    {og_site_name: 'og:site_name', content: 'TDS – Timing Data Service'},
                    {og_type: 'og:type', content: 'website'},
                    {og_url: 'og:url', content: this.$router.currentRoute.fullPath},
                    {og_image: 'og:image', content: (this.loaded ? this.data.ImageUrl : '')},
                ]
            }
        },
        async mounted() {
            await this.$nextTick()
            this.getBanner()
            this.getNews()
            EventBus.$on('event_changed', () => {
                this.updateEvent()
                this.getEventNews()
            })

        }, computed: {
            events() {
                let events = []
                for (let i = 0; i < this.data.Events.length; i++) {
                    if ((this.data.Events[i].Result >= 2) && (this.data.Events[i].Enabled))
                        events.push(this.data.Events[i])
                }

                return events
            },
            msg_race_generic() {
                if (!this.data || this.data.InfoMessages.length <= 0) return false
                let msgs = []
                for (let i = 0; i < this.data.InfoMessages.length; i++)
                    if (this.data.InfoMessages[i].Type === 1)
                        msgs.push(this.data.InfoMessages[i].Text)
                if (msgs.length <= 0) return false
                return msgs
            }, msg_entry_lookup() {
                if (!this.data || this.data.InfoMessages.length <= 0) return false
                let msgs = []
                for (let i = 0; i < this.data.InfoMessages.length; i++)
                    if (this.data.InfoMessages[i].Type === 2)
                        msgs.push(this.data.InfoMessages[i].Text)
                if (msgs.length <= 0) return false
                return msgs
            }, hasMessages() {
                if (this.msg_race_generic) return true
                if (this.msg_entry_lookup) return true
                if (this.msg_starting_grids) return true
                return false
            }, label() {
                // Se non ho eventi, non ho label
                // if (this.events.length <= 0) return false

                let labels = []
                let added = {}
                for(let i = 0;  i < this.data.Events.length; i++) {
                    let lbl = this.data.Events[i].Labels
                    if(lbl.length) {
                        for (let j = 0; j < lbl.length; j++) {
                            if (!added[lbl[j]]) {
                                labels.push({label: lbl[j], name: lbl[j]})
                                added[lbl[j]] = true
                            }
                        }
                    }
                }

                // Se non ho label ritorno false
                if (labels.length <= 0) return false

                // Se le labels sono minore del numero degli eventi
                // vuol dire che non tutti gli eventi hanno una label e quindi devo specificare quali di questi ce l'hanno
                if (labels.length < this.events.length)
                    return labels

                // Verifico se sono tutte uguali
                let lbl = labels[0].label
                for (let i = 0; i < labels.length; i++) {
                    // Se anche solo una è diversa, allora devo mostrarle tutte
                    if (labels[i].label !== lbl)
                        return labels
                }

                // Se sono tutti uguali basta che mostro una sola label che vale per tutta la race
                return lbl
            }
        }, methods: {
            updateEvent() {
                if (this.$refs.classifica)
                    this.event = this.$refs.classifica.event
            },
            async getNews() {
                let data = await this.get(this.id + '/news/generic')
                this.newsList.generic = data.NewsList

                if (this.newsList.generic.length > 0)
                    window.addEventListener('scroll', this.scrollNewsList)
            }, modaleNews(news) {
                this.track('navigation', 'news', this.data.TrackingCategory, this.event.Name)
                this.mod_news = news
                this.$refs.news.show()
            }, async getEventNews() {
                let data = await this.get(this.id + '/news/' + this.event.ID)
                this.newsList.event = data.NewsList
            }, scrollNewsList() {
                if (this.newsList.generic.length <= 0)
                    return false

                let supportPageOffset = window.pageYOffset !== undefined
                let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat')
                // Verifico di quanto siamo scrollati verticalmente
                let scroll_position = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop

                let ret = this.$refs.newsListGeneric.getBoundingClientRect()
                this.posNewsList = ret.top + this.offsetNewsList + scroll_position
                scroll_position += window.innerHeight

                // Se sono troppo vicino ( o le ho superate ) faccio scomparire il box
                this.showBannerNewsList = (scroll_position < this.posNewsList)
            }, onShowVerifica() {
                EventBus.$emit('verifica_onShow')
            }, onHideVerificaIscrizione(evt) {
                EventBus.$emit('verifica_onHide', evt)
            }
        }
    }
</script>
